import React, { Component } from 'react';

import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { get } from 'lodash';

import {
  getDataFilters,
  updateFormNegoce,
  getDataRaw
} from '../../../actions/negoce';
import { formatDataOptions, formatDataCheckOptions } from '../helper';

import Negoce from '../index';
import NegoceFilters from '../components/NegoceFilter';
import ExportButton from '../../../components/Export/Button';
import Card from '../../../components/Card';
import Spinner from '../../../components/Spinner';
import RawCard from '../components/RawCard';

const NegoceContainer = styled.div`
  .negoceRowContainer {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 25px;
  }
`;

class RawData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  async componentDidMount() {
    await this.formatDataFilters();
    this.findRaw();
  }

  async formatDataFilters() {
    await this.props.getDataFilters();

    [
      {
        type: 'currentWine',
        data: this.props.wines || [],
        keys: {
          value: 'wine_id',
          label: 'wine_name'
        }
      },
      {
        type: 'currentCampaign',
        data: this.props.campaigns || [],
        keys: {
          value: 'campaign_id',
          label: 'campaign_name'
        }
      },
      {
        type: 'currentSales',
        data: this.props.salesTypes || [],
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      },
      {
        type: 'currentNegociant',
        data: this.props.negociants || [],
        keys: {
          value: 'negociant_id',
          label: 'negociant_name'
        }
      }
    ].map((filterParams) => {
      this.setDefaultFilter(filterParams);
    });
  }

  setDefaultFilter({ type, data, keys }) {
    const { updateFormNegoce, form } = this.props;
    const typeExist = get(form, type);
    if (!typeExist) {
      const { value, label } = keys;
      const defaultOptions = data.find(({ is_default }) => is_default === true);
      if (defaultOptions) {
        updateFormNegoce({
          [type]: {
            value: get(defaultOptions, value),
            label: get(defaultOptions, label)
          }
        });
      }
    }
  }

  async handleChangeFilters({ type, data }) {
    this.setState({ loading: true });

    if (get(this.props.form, type)) {
      this.setDefaultFilter({
        type,
        data,
        keys: {
          value: 'sale_type_id',
          label: 'sale_type_name'
        }
      });
    }

    await this.props.updateFormNegoce({
      [type]: data
    });
    return this.findRaw();
  }

  async findRaw() {
    this.setState({ loading: true });
    const campaignId = get(this.props.currentCampaign, 'value') || -1;
    const negociantId = get(this.props.currentNegociant, 'value') || -1;
    const wineId = get(this.props.currentWine, 'value') || -1;
    const saleTypeId = get(this.props.currentSales, 'value') || -1;

    await this.props.getDataFilters(campaignId);
    await this.props.getDataRaw({
      campaignId,
      negociantId,
      wineId,
      saleTypeId
    });

    this.setState({ loading: false });
  }

  render() {
    const campaignsData = this.props.campaigns || [];
    const salesTypesData = this.props.salesTypes || [];
    const winesData = this.props.wines || [];
    const negociantsData = this.props.negociants || [];
    const currentSales = this.props.currentSales;
    const campaignId = get(this.props.currentCampaign, 'value');
    const negociantId = get(this.props.currentNegociant, 'value');
    const wineId = get(this.props.currentWine, 'value');
    const saleTypeId = get(this.props.currentSales, 'value');

    const optionsCampaign = formatDataOptions(campaignsData, {
      value: 'campaign_id',
      label: 'campaign_name'
    });

    const defaultCampain = optionsCampaign[0];
    const defaultCampainId = defaultCampain?.value;

    const optionsSales = formatDataCheckOptions(salesTypesData, {
      value: 'sale_type_id',
      label: 'sale_type_name',
      is_default: 'is_default',
      selected_option: get(currentSales, 'value')
    });
    const optionsWine = formatDataOptions(winesData, {
      value: 'wine_id',
      label: 'wine_name'
    });
    const optionsNegociants = formatDataOptions(negociantsData, {
      value: 'negociant_id',
      label: 'negociant_name'
    });

    const rawData = get(this.props.raw, 'rows', []);

    return (
      <Negoce>
        <NegoceContainer>
          <Card>
            <div className="negoceRowContainer">
              <NegoceFilters
                wineFilter={{
                  selectedOption: this.props.currentWine,
                  options: optionsWine,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentWine',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.wines'),
                  placeholder: I18n.t('negoce.filters.winesPlaceholder')
                }}
                campaignFilter={{
                  selectedOption: this.props.currentCampaign || defaultCampain,
                  options: optionsCampaign,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentCampaign',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.date'),
                  placeholder: I18n.t('negoce.filters.datePlaceholder')
                }}
                salesFilter={{
                  disabled: false,
                  label: I18n.t('negoce.filters.salesTypes'),
                  returnValue: true,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentSales',
                      data: {
                        label: I18n.t('negoce.filters.salesTypes'),
                        value: value
                      }
                    });
                  },
                  radioButtons: optionsSales
                }}
                negociantsFilter={{
                  selectedOption: this.props.currentNegociant,
                  options: optionsNegociants,
                  onChange: (value) => {
                    this.handleChangeFilters({
                      type: 'currentNegociant',
                      data: value
                    });
                  },
                  label: I18n.t('negoce.filters.negociants'),
                  placeholder: I18n.t('negoce.filters.negociantsPlaceholder')
                }}
              />
              <ExportButton
                options={['xls']}
                paths={{
                  xls: `/negociant/campaign/${
                    campaignId || defaultCampainId
                  }/raw_data/xls`
                }}
                newApi
              />
            </div>
          </Card>
          <RawCard
            data={rawData}
            campaignId={campaignId}
            negociantId={negociantId}
            saleTypeId={saleTypeId}
            wineId={wineId}
          />
          <Spinner loading={this.state.loading} />
        </NegoceContainer>
      </Negoce>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    salesTypes: state.negoce.data.sale_types,
    campaigns: state.negoce.data.campaigns,
    wines: state.negoce.data.wines,
    negociants: state.negoce.data.negociants,
    raw: state.negoce.data.raw,
    currentCampaign: state.negoce.form.currentCampaign,
    currentSales: state.negoce.form.currentSales,
    currentWine: state.negoce.form.currentWine,
    currentNegociant: state.negoce.form.currentNegociant,
    form: state.negoce.form
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataFilters: (campaignId) => dispatch(getDataFilters(campaignId)),
    updateFormNegoce: (data) => dispatch(updateFormNegoce(data)),
    getDataRaw: ({ campaignId, saleTypeId, wineId, negociantId }) =>
      dispatch(getDataRaw({ campaignId, saleTypeId, wineId, negociantId }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RawData);
